import React from "react";
import { App } from "./App";
import { PublicClientApplication } from "@azure/msal-browser";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { msalConfig } from "./auth/authConfig";
import { Login } from "./pages/Login";
import { FluentProvider } from "@fluentui/react-components";
import { lightTheme } from "./theme";
export const msalInstance = new PublicClientApplication(msalConfig);

export const Root = () => {
  const getComponent = () => {
    switch (window.location.host) {
      case "test.365robust.se":
        return (
          <FluentProvider theme={lightTheme}>
            <MsalProvider instance={msalInstance}>
              <AuthenticatedTemplate>
                <App />
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <Login />
              </UnauthenticatedTemplate>
            </MsalProvider>
          </FluentProvider>
        );
      default:
        return (
          <FluentProvider theme={lightTheme}>
            <App />
          </FluentProvider>
        );
    }
  };
  return getComponent();
};
